import React from "react";
import { usePage } from "@inertiajs/react";
import PoweredByFaithConnect from "./PoweredByFaithConnect";

/**
 * Copyright + optional FaithConnect attribution bar for layouts without a full Footer.
 * Renders nothing when platform branding is disabled.
 */
export default function BrandAttribution({ className = "" }) {
    const { showPoweredByFaithConnect, appName, websiteUrl } = usePage().props;

    if (!showPoweredByFaithConnect) {
        return null;
    }

    return (
        <div
            className={`py-4 text-center text-sm text-gray-600 dark:text-gray-400 ${className}`}
        >
            © {new Date().getFullYear()} Copyright:{" "}
            <span className="text-black dark:text-white font-semibold">
                <a
                    className="text-blue-600 dark:text-blue-400"
                    href={websiteUrl || "#"}
                >
                    {appName}
                </a>
            </span>
            <PoweredByFaithConnect />
        </div>
    );
}
